





































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Vat, VatCorrection } from '@/api';
import { VatCorrectionService } from '@/services/vat-correction-service';
import Toast from '@/components/display/toast.vue';
@Component({})
export default class EscalatedAlertCardUserTab extends Vue {
    @Prop({ type: Object })
    public vat!: Vat;

    public loading = true;
    public toast: Toast = new Toast();
    public corrections: VatCorrection[] = [];
    public vatCorrectionService: VatCorrectionService = new VatCorrectionService();

    public fields = [
        {
            key: 'id',
            label: 'Id',
        },
        {
            key: 'formula_id',
            label: 'Formula',
        },
        {
            key: 'user_id',
            label: 'User',
        },
        {
            key: 'formula_parameters',
            label: 'Paramaters',
        },
        {
            key: 'allocated_at',
            label: 'Created',
        },
        {
            key: 'unallocated_at',
            label: 'Removed',
        },
    ];

    public async mounted() {
        this.loading = true;
        await this.loadCorrections();
    }

    public async loadCorrections() {
        const { errorMessage, corrections } = await this.vatCorrectionService.getCorrections(this.vat.id);
        if (errorMessage) {
            this.corrections = [];
            this.toast.makeToast(errorMessage, 'Error', 'danger', true);
        } else {
            this.corrections = corrections?.reverse() ?? [];
        }
        this.loading = false;
    }
}
